module.exports = __webpack_public_path__ + "static/media/hitachi4.875adac3.png";